<script context="module">
  export function callReloadClipboard () {
    if(rlCpb !== null) rlCpb()
  }
  export function callDelItemClipboard (itemId) {
    if(delItm !== null) delItm(itemId)
  }
  let rlCpb = null
  let delItm = null
</script>

<script>
  import ClipboardJS from 'clipboard/dist/clipboard.min'
  import { clipboardData, errorState, errorMessage, username, bearerToken } from './services/stores.js'
  import { ButtonGroup, Button, ListGroup, ListGroupItem, Spinner, Container, Row, Col, Icon } from '@sveltestrap/sveltestrap'
  import { fade } from 'svelte/transition'
  import pastyClient from './lib/pastyclient.lib.js'
  import { createEventDispatcher, onMount, beforeUpdate, afterUpdate } from 'svelte'
  import { notifier } from '@beyonk/svelte-notifications'
  import { _ } from 'svelte-i18n'


  const clipboard = new ClipboardJS('.clipboard')
  const dispatch = createEventDispatcher()

  let clipboardVisible = true
  let clipboardLoaded = false

  export async function getItems() {
    const clipboard = await pastyClient.getClipboard($bearerToken)
    return clipboard
  }

  const reloadClipboard = () => {
    getItems().then(items => {
      $clipboardData = items
      clipboardLoaded = true
    }).catch(err => {
      if (err.message === 'Invalid login credentials'){
        dispatch('login_failed', {
          failed: 'clipboardList'
        })
      } else {
        let message = err.message || $_('error.unknown')
        notifier.danger(err.message, { timeout: 5000 })
      }
    })
  }
  rlCpb = reloadClipboard

  const handleDeleteClick = (event) => {
    let id = event.currentTarget.getAttribute('data-pasty-id')
    delItem(id)
  }

  async function delItem(id) {
    if (id === null) return
    try {
      await pastyClient.delItem(id, $bearerToken)
      notifier.warning($_('notif.item_deleted'), { timeout: 5000 })
      reloadClipboard()
    } catch (err) {
      if (err.message === 'Invalid login credentials'){
        dispatch('login_failed', {
          failed: 'clipboardDel',
          itemId: id
        })
      } else {
        let message = err.message || $_('error.unknown')
        notifier.danger(err.message, { timeout: 5000 })
      }
    }
  }
  delItm = delItem

  function isUrl(text) {
      var urlRegex =/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      return urlRegex.test(text)
  }

  reloadClipboard()
</script>

{#if clipboardLoaded}
	{#each $clipboardData as item}
    {#if clipboardVisible}
      <div transition:fade>
        <Container class="w-100 my-2">
          <ButtonGroup class="d-flex">
            {#if isUrl(item.item)}
              <Button
                data-pasty-link={item.item}
                href={item.item}
                target="_blank"
                color="primary"
                class="col-8 col-md-10 text-left"
                style="white-space:normal !important; word-wrap: break-word; "
                outline>
          		  {item.item}
              </Button>
            {:else}
              <Button
                data-pasty-link={item.item}
                data-clipboard-text="{item.item}"
                color="primary"
                class="col-8 col-md-10 text-left clipboard"
                style="white-space:normal !important; word-wrap: break-word; "
                on:click={() => { notifier.info($_('notif.item_copied'), { timeout: 5000 }) }}
                outline>
          		  {item.item}
              </Button>
            {/if}
          	<Button
              color="primary"
              class="col-2 col-md-1 clipboard"
              data-clipboard-text="{item.item}"
              title="{$_('clipboard.title.delete')}"
              on:click={() => { notifier.info($_('notif.item_copied'), { timeout: 5000 }) }}
              outline>
          		<Icon name="clipboard" />
          	</Button>
            <Button
              color="primary"
              class="col-2 col-md-1"
              data-pasty-id="{item._id}"
              title="{$_('clipboard.title.delete')}"
              on:click={handleDeleteClick}
              outline>
              <Icon name="trash" />
            </Button>
          </ButtonGroup>
        </Container>
      </div>
    {/if}
	{/each}
{:else}
  <Container class="m-5">
    <Row>
      <Col class="col-3">
        <Spinner color="primary" class="align-middle" type="grow" />
        &nbsp;Loading Clipboard
      </Col>
    </Row>
  </Container>
{/if}
